module.exports = __webpack_public_path__ + "static/media/cognitev.19b758c4.png";